import axios from "axios";
import { documentAction } from "../actionTypes";
import { url } from "../../config/config";

export const documentListInitiate = () => ({ type: documentAction.DOCUMENT_LIST_INITIATE })
export const documentListSuccess = (data) => ({ type: documentAction.DOCUMENT_LIST_SUCCESS, payload: data })
export const documentListFailure = () => ({ type: documentAction.DOCUMENT_LIST_FAILURE })

export const uploadInitiate = () => ({ type: documentAction.DOCUMENT_UPLOAD_INITIATE })
export const uploadProgress = (percent) => ({ type: documentAction.DOCUMENT_UPLOAD_PROGRESS, payload: percent })
export const uploadSuccess = () => ({ type: documentAction.DOCUMENT_UPLOAD_SUCCESS })
export const uploadFailure = () => ({ type: documentAction.DOCUMENT_UPLOAD_FAILURE })

export function getDocumentList(params) {
    return async dispatch => {
        dispatch(documentListInitiate())
        try {
            const { data } = await axios.get(`${url}documents`, { params })
            dispatch(documentListSuccess(data))
            return data
        } catch (err) {
            dispatch(documentListFailure())
            throw err
        }
    }
}

export function uploadDocuments({ files, title, item }) {
    return async dispatch => {
        const form = new FormData()
        files.forEach(file => form.append('files', file))
        if (title) form.append('title', title)
        if (item) form.append('item', item)

        dispatch(uploadInitiate())
        try {
            const { data } = await axios.post(`${url}documents`, form, {
                onUploadProgress: e => e.total && dispatch(uploadProgress(Math.round((e.loaded * 100) / e.total))),
            })
            dispatch(uploadSuccess())
            return data
        } catch (err) {
            dispatch(uploadFailure())
            throw err
        }
    }
}

export function deleteDocument(id) {
    return async () => {
        const { data } = await axios.delete(`${url}documents/${id}`)
        return data
    }
}

export function getDocumentDetails(id) {
    return async () => {
        const { data } = await axios.get(`${url}documents/${id}`)
        return data
    }
}

export function scanDocument(id) {
    return async () => {
        const { data } = await axios.post(`${url}documents/${id}/scan`)
        return data
    }
}

export function importDocumentItems(id, body) {
    return async () => {
        const { data } = await axios.post(`${url}documents/${id}/import`, body)
        return data
    }
}
